export type PostFilterType = 'all' | 'micro' | 'zine' | 'book' | 'event' | 'job'
export type PostFilterSort = 'newest' | 'popular'
// - subscriptions: paid-content-only (client-side)
// - my_subscriptions: posts from creators you are subscribed to (backend mode=subscriptions)
export type PublishMode = 'all' | 'saved' | 'subscriptions' | 'my_subscriptions'

export type PublishFilters = {
  q?: string
  mode: PublishMode
  type: PostFilterType
  category?: string
  sort: PostFilterSort
  is_local?: boolean
  location_mode?: 'anywhere' | 'near_me' | 'city'
  near_lat?: number | null
  near_lng?: number | null
  radius_km?: number | null
  city?: string
  region?: string
  country?: string
}

export const DEFAULT_PUBLISH_FILTERS: PublishFilters = {
  q: '',
  mode: 'all',
  type: 'all',
  category: '',
  sort: 'newest',
  is_local: false,
  location_mode: 'anywhere',
  near_lat: null,
  near_lng: null,
  radius_km: null,
  city: '',
  region: '',
  country: '',
}

export function normalizePublishFilters(input?: Partial<PublishFilters> | null): PublishFilters {
  return {
    q: input?.q ?? '',
    mode: (input?.mode as PublishMode) ?? 'all',
    type: (input?.type as PostFilterType) ?? 'all',
    category: (input?.category as string) ?? '',
    sort: (input?.sort as PostFilterSort) ?? 'newest',
    is_local: Boolean(input?.is_local),
    location_mode: (input?.location_mode as any) ?? 'anywhere',
    near_lat: input?.near_lat ?? null,
    near_lng: input?.near_lng ?? null,
    radius_km: input?.radius_km ?? null,
    city: (input?.city as string) ?? '',
    region: (input?.region as string) ?? '',
    country: (input?.country as string) ?? '',
  }
}

export function serializePublishFilterParams(input?: PublishFilters | null): Record<string, string> {
  const f = normalizePublishFilters(input ?? undefined)
  const params: Record<string, string> = {}
  if (f.q && f.q.trim()) params.q = f.q.trim()
  if (f.mode && f.mode !== 'all') {
    params.mode = f.mode === 'my_subscriptions' ? 'subscriptions' : f.mode
  }
  if (f.type && f.type !== 'all') {
    params.type = f.type
    params.format = f.type
  }
  if (f.category && f.category.trim()) params.category = f.category.trim()
  if (f.is_local) params.is_local = 'true'
  if (f.location_mode === 'near_me' && f.near_lat != null && f.near_lng != null) {
    params.near_lat = String(f.near_lat)
    params.near_lng = String(f.near_lng)
    if (f.radius_km != null && Number.isFinite(Number(f.radius_km))) params.radius_km = String(Math.max(1, Number(f.radius_km)))
  } else if (f.location_mode === 'city') {
    if (f.city && f.city.trim()) params.city = f.city.trim()
    if (f.region && f.region.trim()) params.region = f.region.trim()
    if (f.country && f.country.trim()) params.country = f.country.trim().toUpperCase()
  }
  if (f.sort) params.sort = f.sort
  return params
}
